import Theme from './Theme';

export default {
  base: Theme,
};
